<template lang="pug">
    .md-content
        PmBreadcrumbs(:view="lenguageNavSelected.breadcrumb", :section="section", :lang="lenguage")
        PmBanner(:name="lenguageNavSelected.title", :image="banner")
        PmContentBox(:content="lenguageNavSelected.box")
        .container
            .row
                .col-md-4
                    PmSidebar(:options="lenguageNavSelected.nav", :contact="false", :lang="lenguage")
                .col-md-8
                    transition(name="fade", mode="out-in", @beforeLeave="beforeLeave", @enter="enter", @afterEnter="afterEnter")
                        router-view(:lang="lenguage")

</template>

<script>
import PmBreadcrumbs from '@components/atoms/PmBreadCrumbs.vue'
import PmBanner from '@components/atoms/PmBanner.vue'
import PmContentBox from '@components/atoms/PmContentBox.vue'
import PmSidebar from '@components/atoms/PmSidebar.vue'

import aboutBanner from '@img/about/Banner_ABOUT_ATP.jpg'

export default {
    props: ["lang"],
    components: {
        PmBreadcrumbs, PmBanner, PmContentBox, PmSidebar
    },
    created: function(){
        this.$data.lenguage = this.lang
        console.log(this.lang)
    },
    mounted: function(){
        this.$data.section = this.$route.name;
        let to = this.moveToDown
        ? this.$refs.description.offsetTop - 60
        : 0

    window.scroll({
        top: to,
        left: 0,
        behavior: 'smooth'
    })

    this.moveToDown = !this.moveToDown
    },
    data: function(){
        return{
            lenguage: 'ES',
            enContent: {
                nav: [
                    {name:"What We Do", path: "/en/about/what-we-do"},
                    {name:"Our History", path: "/en/about/our-history"},
                    {name:"Management Team", path: "/en/about/management-team"},
                    {name:"Our Portfolio", path: "/en/about/our-portfolio"},
                    {name:"Our Vision for 5G", path:"/en/about/our-vision-for-5g"}
                ],
                box: 'ATP is the largest privately owned provider of digital infrastructure in the Andean region. Our company owns, operates and leases assets across our portfolio of telecommunications towers, rooftops, small cells, and optical fiber networks.',
                title: 'ABOUT ATP',
                breadcrumb: {name:'ABOUT', link:'/en/about/what-we-do'}
            },
            esContent: {
                nav: [
                    {name:"Qué Hacemos", path: "/es/acerca-de-atp/que-hacemos"},
                    {name:"Nuestra Historia", path: "/es/acerca-de-atp/nuestra-historia"},
                    {name:"Equipo Directivo", path: "/es/acerca-de-atp/equipo-directivo"},
                    {name:"Nuestro Portafolio", path: "/es/acerca-de-atp/nuestro-portafolio"},
                    {name:"Nuestra Visión 5G", path:"/es/acerca-de-atp/nuestra-vision-5g"}
                ],
                box: 'Somos el operador privado de infraestructura digital más grande de la región andina. Operamos y arrendamos activos de nuestro portafolio de torres, azoteas, Small Cells y fibra óptica.',
                title: 'ACERCA DE ATP',
                breadcrumb: {name:'ACERCA DE ATP', link:'/es/acerca-de-atp/que-hacemos'}
            },
            banner: aboutBanner,
            
            section: ''
        }
    },
    computed: {
        lenguageNavSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.enContent : this.$data.esContent
        }
    },
    methods: {
        beforeLeave(element) {
            this.prevHeight = getComputedStyle(element).height;
        },
        enter(element) {
            const { height } = getComputedStyle(element);

            element.style.height = this.prevHeight;

            setTimeout(() => {
                element.style.height = height;
            });
        },
        afterEnter(element) {
            element.style.height = 'auto';  
        }
    }
}
</script>

<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/components/organisms/PmAbout.vue